import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(["cards-wrapper", `cards-wrapper--${_ctx.columns}`])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: item[_ctx.itemKey],
        class: "cards-wrapper__item"
      }, [
        _renderSlot(_ctx.$slots, "default", {
          item: item,
          index: index
        }, undefined, true)
      ]))
    }), 128))
  ], 2))
}